export default __webpack_public_path__ + "static/media/notification.09a4527a.mp3";